import React, { useState, useEffect, useRef } from "react";
import { Dropdown, ButtonGroup } from "react-bootstrap";
import Loader from "../loader/loader";
import AddDropdown from "./AddDropdown";
import { useGetAllDropdownMutation, useGetDropdownMutation, useGetCategoryDropdownMutation } from "./Api";
import Pagination from "../Pagination/Pagination";
import { Logout, shouldLogout } from '../Common/Common'
import { useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";

const DropdownManagement = () => {

    const [getAllDropdownApi, { isLoading }] = useGetAllDropdownMutation()
    const [getdropdownApi, { isLoading: getDropdownLoading }] = useGetDropdownMutation()
    const [getCategoryApi, { isLoading: getCategoryLoading }] = useGetCategoryDropdownMutation()

    const [dropdown, setDropdown] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [status, setStatus] = useState(false)
    const [categoryForDropdown, setCategoryForDropdown] = useState([])
    const [statusFilter, setStatusFilter] = useState("");
    const [search, setSearch] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState(search);

    const navigate = useNavigate()

    const requestIdRef = useRef(0);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
        }, 1000); // 1000ms delay

        return () => clearTimeout(handler); // cleanup on next effect
    }, [search]);


    useEffect(() => {
        getAllDropdown()
    }, [rowsPerPage, currentPage, status, statusFilter, debouncedSearch]);


    useEffect(() => {
        getCategoriesValue()
    }, [])

    useEffect(() => {
        setCurrentPage(1);
    }, [debouncedSearch, statusFilter]);

    const getAllDropdown = async () => {
        try {

            const requestId = ++requestIdRef.current;

            const response = await getAllDropdownApi({
                page: currentPage,
                limit: rowsPerPage,
                filter: statusFilter,
                search: debouncedSearch
            })

            if (requestId !== requestIdRef.current) return;

            if (response?.data?.success) {
                setDropdown(response?.data?.data?.dropdown)
                setTotalRecords(response?.data?.data?.pagination.total || 0);
                setTotalPages(response?.data?.data?.pagination.totalPages || 1);
            } else {
                if (shouldLogout(response.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }


    const startEntry = totalRecords === 0
        ? 0
        : (currentPage - 1) * rowsPerPage + 1;

    const endEntry = Math.min(currentPage * rowsPerPage, totalRecords);


    // Drawer open close
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    // Open drawer for creating new dropdown
    const handleCreateDropdown = () => {
        setIsDrawerOpen(true);
    };

    const handleCloseDrawer = () => {
        setIsDrawerOpen(false);
    };

    const handleSave = () => {
        handleCloseDrawer(); // Close 
        setStatus(!status)  // for get new data after new role upload

    };

    // Update Drawer
    const [isUpdateDrawerOpen, setIsUpdateDrawerOpen] = useState(false);
    const [dropdownData, setDropdownData] = useState()

    const handleUpdateCloseDrawer = () => {
        setIsUpdateDrawerOpen(false);
    };

    const handleUpdateSave = () => {
        handleUpdateCloseDrawer(); // close toggle
        setStatus(!status)  // for get new data after new role upload
    };


    const getDropdownById = async (id) => {
        try {
            const response = await getdropdownApi({ id: id })

            if (response.data.success) {
                setIsUpdateDrawerOpen(true)
                setDropdownData(response?.data?.data)
            } else {
                if (shouldLogout(response.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    const getCategoriesValue = async () => {
        try {
            const response = await getCategoryApi()
            if (response.data.success) {
                setCategoryForDropdown(response.data.data)
            } else {
                if (shouldLogout(response.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    return (
        <div>
            {isLoading || getDropdownLoading || getCategoryLoading ? <Loader /> :
                <div>
                    {/* Header */}
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <ul className="breadcrumb mb-0">
                                <li className="breadcrumb-item">Dropdown Management</li>
                                <li className="breadcrumb-item active">Dropdown</li>
                            </ul>
                        </div>
                    </div>

                    <div className="main-content">
                        <div className="row">
                            <div className="p-6">
                                {/* Title */}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div>
                                        <h3 className="h4 mb-1 drawer-header">
                                            Dropdown Management
                                        </h3>
                                        <p className="mb-0 text-muted">
                                            Manage Dropdown
                                        </p>
                                    </div>
                                    <button className="btn btn-primary" onClick={handleCreateDropdown}>
                                        Create Dropdown
                                    </button>
                                </div>

                                <div className="card p-3 mb-4">

                                    <div className="card shadow-sm border-0 p-3 mb-4">
                                        <div className="row justify-content-end g-3">

                                            {/* Search */}
                                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                                {/* <label className="form-label small text-muted mb-1">Search</label> */}
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Search dropdowns by name..."
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                />
                                            </div>

                                            {/* Status Dropdown */}
                                            <div className="col-12 col-sm-6 col-md-3 col-lg-2">
                                                {/* <label className="form-label small text-muted mb-1">Status</label> */}

                                                <select
                                                    className="form-select form-select-sm"
                                                    value={statusFilter || "all"}
                                                    onChange={(e) =>
                                                        setStatusFilter(e.target.value === "all" ? "" : e.target.value)
                                                    }
                                                >
                                                    <option value="all">All</option>

                                                    {/* {categoryForDropdown.map((opt) => (
                                                        <option key={opt.id} value={opt.id}>
                                                            {opt.category}
                                                        </option>
                                                    ))} */}
                                                    {categoryForDropdown
                                                        .slice() // make a copy to avoid mutating original array
                                                        .sort((a, b) => a.category.localeCompare(b.category)) // alphabetical sort
                                                        .map((opt) => (
                                                            <option key={opt.id} value={opt.id}>
                                                                {opt.category}
                                                            </option>
                                                        ))}
                                                </select>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-hover mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Category Name</th>
                                                    <th>Sub Category Name</th>
                                                    <th>Dropdown Name</th>
                                                    <th>Display Order</th>
                                                    <th>Status</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {!isLoading && dropdown?.length > 0 ? (
                                                    dropdown.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.category_name}</td>
                                                            <td>{item.sub_category_name ? item.sub_category_name : '-'}</td>
                                                            <td>{item.dropdown_name}</td>
                                                            <td>{item.sort_order}</td>
                                                            <td>{item.status.charAt(0).toUpperCase() + item.status.slice(1)}</td>
                                                            <td
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => getDropdownById(item.id)}
                                                            >
                                                                <FaEdit size={18} />
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="6" className="text-center text-muted py-4" style={{ fontStyle: "italic", backgroundColor: "#f9f9f9" }}>
                                                            No data found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                        {/* Pagination */}

                                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3 gap-2">

                                            <div className="d-flex align-items-center gap-1 small">

                                                <span>Show</span>

                                                <select
                                                    className="form-select form-select-sm page-size-select"
                                                    value={rowsPerPage}
                                                    onChange={(e) => {
                                                        setRowsPerPage(Number(e.target.value));
                                                        setCurrentPage(1);
                                                    }}
                                                >
                                                    <option value={5}>5</option>
                                                    <option value={10}>10</option>
                                                    <option value={15}>15</option>
                                                </select>

                                                <span>entries</span>

                                            </div>

                                            <div className="small text-muted">
                                                Showing {startEntry} to {endEntry} of {totalRecords} entries
                                            </div>

                                            <Pagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                maxPagesToShow={rowsPerPage}
                                                onPageChange={(page) => setCurrentPage(page)}
                                            />

                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>

                    {isDrawerOpen && (
                        <AddDropdown
                            mode="add"
                            onClose={handleCloseDrawer}
                            onSave={handleSave}
                        />

                    )}

                    {isUpdateDrawerOpen && (
                        <AddDropdown
                            mode="update"
                            onClose={handleUpdateCloseDrawer}
                            onSave={handleUpdateSave}
                            data={dropdownData}
                        />
                    )}
                </div>

            }
        </div>

    );
};

export default DropdownManagement;  
